import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/tuffexProductCatalogueWorkspaceCapability/domain/TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type TuffexProductCatalogueWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.tuffexProductCatalogue> & {
    fixedUdoTemplates: {
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.productApiLog]: {
            udoAdditionalColumnIds: {
                error: Uuid;
                requestBody: Uuid;
                requestHeaders: Uuid;
                responseBody: Uuid;
                responseHeaders: Uuid;
                responseStatus: Uuid;
            };
        };
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.tag]: {
            udoAdditionalColumnIds: {
                displayName: Uuid;
                resourceType: Uuid;
            };
        };
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.variantAttribute]: {
            udoAdditionalColumnIds: {
                displayName: Uuid;
            };
        };
    };
    catalogueUdoTemplates: Record<Uuid, {udoTemplateId: Uuid}>;
};

export const tuffexProductCatalogueWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.productApiLog]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                error: uuidZodValidator,
                requestBody: uuidZodValidator,
                requestHeaders: uuidZodValidator,
                responseBody: uuidZodValidator,
                responseHeaders: uuidZodValidator,
                responseStatus: uuidZodValidator,
            }),
        }),
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.tag]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({displayName: uuidZodValidator, resourceType: uuidZodValidator}),
        }),
        [TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey.variantAttribute]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({displayName: uuidZodValidator}),
        }),
    }),
    catalogueUdoTemplates: zod.record(uuidZodValidator, zod.strictObject({udoTemplateId: uuidZodValidator})),
}) satisfies zod.ZodType<TuffexProductCatalogueWorkspaceCapabilityUdoBindings>;
